// extracted by mini-css-extract-plugin
module.exports = {"root":"BackgroundBlock_root__SnXmW"};